
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Refund terms',
    sec1Title: 'When a refund is possible',
    sec1Intro: 'A refund request may be reviewed if:',
    sec1Item1: 'money was charged but the balance was not credited;',
    sec1Item2: 'a technical error or a duplicate payment occurred;',
    sec1Item3: "paid digital content was not provided due to SHOT's fault;",
    sec1Item4: 'other confirmed technical problems were identified.',
    sec1Note:
      'Each request is reviewed individually. A request must be submitted no later than 30 calendar days from the top-up date.',
    sec2Title: 'When a refund is not possible',
    sec2Intro: 'A refund is not made if:',
    sec2Item1: 'the funds have already been used or multiplied;',
    sec2Item2: 'the balance, digital content or in-game item was successfully received;',
    sec2Item3: "the item was transferred to the user's Steam account;",
    sec2Item4: 'the user changed their mind after payment or did not read the Service terms;',
    sec2Item5: 'the request concerns the outcome of game mechanics;',
    sec2Item6:
      'the user violated the Service terms, or signs of fraud or abuse of the refund system were identified;',
    sec2Item7: 'more than 30 calendar days have passed since the top-up.',
    sec3Title: 'How to contact support',
    sec3Before: 'You need to contact SHOT support via the contacts listed in the ',
    sec3LinkWord: 'Support',
    sec3After:
      ' section. Payment details, additional data or documents may be required for verification.',
    sec4Title: 'Review period',
    sec4Text:
      'A request is reviewed after all the necessary information is received. The standard period is up to 30 calendar days. If additional verification or interaction with payment systems is required, the period may be extended.',
    policyLink: 'Detailed refund policy',
  },
  ru: {
    title: 'Условия возврата',
    sec1Title: 'Когда возможен возврат',
    sec1Intro: 'Запрос на возврат может быть рассмотрен, если:',
    sec1Item1: 'деньги были списаны, но баланс не был зачислен;',
    sec1Item2: 'произошла техническая ошибка или дублирование платежа;',
    sec1Item3: 'оплаченный цифровой контент не был предоставлен по вине SHOT;',
    sec1Item4: 'выявлены другие подтверждённые технические проблемы.',
    sec1Note:
      'Каждое обращение рассматривается индивидуально. Запрос необходимо подать не позднее 30 календарных дней с момента пополнения.',
    sec2Title: 'Когда возврат невозможен',
    sec2Intro: 'Возврат не производится, если:',
    sec2Item1: 'средства уже были использованы или преумножены;',
    sec2Item2: 'баланс, цифровой контент или игровой предмет были успешно получены;',
    sec2Item3: 'предмет был передан на Steam-аккаунт пользователя;',
    sec2Item4: 'пользователь изменил решение после оплаты или не ознакомился с условиями Сервиса;',
    sec2Item5: 'обращение связано с результатами игровых механик;',
    sec2Item6:
      'пользователь нарушил условия Сервиса либо выявлены признаки мошенничества или злоупотребления системой возвратов;',
    sec2Item7: 'с момента пополнения прошло более 30 календарных дней.',
    sec3Title: 'Как обратиться в поддержку',
    sec3Before: 'Необходимо обратиться в службу поддержки SHOT через контакты, указанные в разделе ',
    sec3LinkWord: 'Поддержка',
    sec3After:
      '. Для проверки могут потребоваться сведения о платеже, дополнительные данные или документы.',
    sec4Title: 'Срок рассмотрения',
    sec4Text:
      'Обращение рассматривается после получения всей необходимой информации. Стандартный срок — до 30 календарных дней. При необходимости дополнительной проверки или взаимодействия с платёжными системами срок может быть увеличен.',
    policyLink: 'Подробная политика возвратов',
  },
  uz: {
    title: 'Qaytarish shartlari',
    sec1Title: 'Qachon qaytarish mumkin',
    sec1Intro: 'Qaytarish soʻrovi koʻrib chiqilishi mumkin, agar:',
    sec1Item1: 'pul yechib olingan, lekin balans hisoblanmagan boʻlsa;',
    sec1Item2: 'texnik xatolik yoki toʻlov takrorlanishi yuz bergan boʻlsa;',
    sec1Item3: 'toʻlangan raqamli kontent SHOT aybi bilan taqdim etilmagan boʻlsa;',
    sec1Item4: 'boshqa tasdiqlangan texnik muammolar aniqlangan boʻlsa.',
    sec1Note:
      'Har bir murojaat alohida koʻrib chiqiladi. Soʻrov toʻldirilgan paytdan boshlab 30 kalendar kundan kechiktirmay yuborilishi kerak.',
    sec2Title: 'Qachon qaytarish mumkin emas',
    sec2Intro: 'Qaytarish amalga oshirilmaydi, agar:',
    sec2Item1: 'mablagʻ allaqachon ishlatilgan yoki koʻpaytirilgan boʻlsa;',
    sec2Item2: 'balans, raqamli kontent yoki oʻyin buyumi muvaffaqiyatli olingan boʻlsa;',
    sec2Item3: 'buyum foydalanuvchining Steam akkauntiga oʻtkazilgan boʻlsa;',
    sec2Item4: 'foydalanuvchi toʻlovdan keyin fikrini oʻzgartirgan yoki Servis shartlari bilan tanishmagan boʻlsa;',
    sec2Item5: 'murojaat oʻyin mexanikasi natijalari bilan bogʻliq boʻlsa;',
    sec2Item6:
      'foydalanuvchi Servis shartlarini buzgan yoki firibgarlik yoxud qaytarish tizimidan suiisteʼmol belgilari aniqlangan boʻlsa;',
    sec2Item7: 'toʻldirilgan paytdan 30 kalendar kundan koʻp vaqt oʻtgan boʻlsa.',
    sec3Title: 'Qoʻllab-quvvatlashga qanday murojaat qilish',
    sec3Before: 'SHOT ',
    sec3LinkWord: 'Qoʻllab-quvvatlash',
    sec3After:
      ' boʻlimida koʻrsatilgan kontaktlar orqali qoʻllab-quvvatlash xizmatiga murojaat qilish kerak. Tekshirish uchun toʻlov maʼlumotlari, qoʻshimcha maʼlumotlar yoki hujjatlar talab qilinishi mumkin.',
    sec4Title: 'Koʻrib chiqish muddati',
    sec4Text:
      'Murojaat barcha zarur maʼlumotlar olingandan keyin koʻrib chiqiladi. Standart muddat — 30 kalendar kungacha. Qoʻshimcha tekshiruv yoki toʻlov tizimlari bilan oʻzaro aloqa zarur boʻlsa, muddat uzaytirilishi mumkin.',
    policyLink: 'Batafsil qaytarish siyosati',
  },
  fa: {
    title: 'شرایط بازگشت وجه',
    sec1Title: 'چه وقت بازگشت وجه ممکن است',
    sec1Intro: 'درخواست بازگشت وجه ممکن است بررسی شود اگر:',
    sec1Item1: 'پول کسر شده اما موجودی شارژ نشده باشد؛',
    sec1Item2: 'خطای فنی یا پرداخت تکراری رخ داده باشد؛',
    sec1Item3: 'محتوای دیجیتال پرداخت‌شده به تقصیر SHOT داده نشده باشد؛',
    sec1Item4: 'مشکل فنی تأییدشده دیگری مشخص شده باشد.',
    sec1Note:
      'هر درخواست جداگانه بررسی می‌شود. درخواست باید حداکثر تا 30 روز تقویمی از تاریخ شارژ ثبت شود.',
    sec2Title: 'چه وقت بازگشت وجه ممکن نیست',
    sec2Intro: 'وجه برگردانده نمی‌شود اگر:',
    sec2Item1: 'پول قبلاً خرج یا چند برابر شده باشد؛',
    sec2Item2: 'موجودی، محتوای دیجیتال یا آیتم درون‌بازی با موفقیت دریافت شده باشد؛',
    sec2Item3: 'آیتم به حساب استیم کاربر منتقل شده باشد؛',
    sec2Item4: 'کاربر بعد از پرداخت نظرش عوض شده یا شرایط سرویس را نخوانده باشد؛',
    sec2Item5: 'درخواست درباره نتیجه مکانیک بازی باشد؛',
    sec2Item6:
      'کاربر شرایط سرویس را نقض کرده باشد، یا نشانه تقلب یا سوءاستفاده از سامانه بازگشت وجه دیده شود؛',
    sec2Item7: 'بیش از 30 روز تقویمی از شارژ گذشته باشد.',
    sec3Title: 'چطور با پشتیبانی تماس بگیریم',
    sec3Before: 'باید از راه‌های تماسِ بخش ',
    sec3LinkWord: 'پشتیبانی',
    sec3After: ' با تیم SHOT تماس بگیری. ممکن است برای بررسی، جزئیات پرداخت، داده یا مدرک بیشتری لازم شود.',
    sec4Title: 'مدت بررسی',
    sec4Text:
      'درخواست بعد از دریافت همه اطلاعات لازم بررسی می‌شود. مدت عادی تا 30 روز تقویمی است. اگر بررسی بیشتر یا هماهنگی با سامانه‌های پرداخت لازم باشد، این مدت طولانی‌تر می‌شود.',
    policyLink: 'سیاست کامل بازگشت وجه',
  },
  pt: {
    title: 'Condições de reembolso',
    sec1Title: 'Quando o reembolso é possível',
    sec1Intro: 'Um pedido de reembolso pode ser analisado se:',
    sec1Item1: 'o dinheiro foi debitado, mas o saldo não foi creditado;',
    sec1Item2: 'houve um erro técnico ou um pagamento duplicado;',
    sec1Item3: 'o conteúdo digital pago não foi entregue por culpa do SHOT;',
    sec1Item4: 'foram identificados outros problemas técnicos confirmados.',
    sec1Note:
      'Cada pedido é analisado individualmente. O pedido deve ser enviado em até 30 dias corridos a partir da data do depósito.',
    sec2Title: 'Quando o reembolso não é possível',
    sec2Intro: 'O reembolso não é feito se:',
    sec2Item1: 'os fundos já foram usados ou multiplicados;',
    sec2Item2: 'o saldo, o conteúdo digital ou o item do jogo foi recebido com sucesso;',
    sec2Item3: 'o item foi transferido para a conta Steam do usuário;',
    sec2Item4: 'o usuário mudou de ideia depois do pagamento ou não leu os termos do Serviço;',
    sec2Item5: 'o pedido se refere ao resultado das mecânicas do jogo;',
    sec2Item6:
      'o usuário violou os termos do Serviço ou foram identificados sinais de fraude ou abuso do sistema de reembolso;',
    sec2Item7: 'passaram mais de 30 dias corridos desde o depósito.',
    sec3Title: 'Como falar com o suporte',
    sec3Before: 'É preciso entrar em contato com o suporte do SHOT pelos contatos indicados na seção ',
    sec3LinkWord: 'Suporte',
    sec3After:
      '. Para a verificação, podem ser necessários dados do pagamento, informações adicionais ou documentos.',
    sec4Title: 'Prazo de análise',
    sec4Text:
      'O pedido é analisado depois que todas as informações necessárias forem recebidas. O prazo padrão é de até 30 dias corridos. Se for necessária uma verificação adicional ou contato com os sistemas de pagamento, o prazo pode ser estendido.',
    policyLink: 'Política de reembolso completa',
  },
  tr: {
    title: 'İade koşulları',
    sec1Title: 'İade ne zaman mümkün',
    sec1Intro: 'İade talebi şu durumlarda incelenebilir:',
    sec1Item1: 'para çekildi ama bakiyeye yansımadı;',
    sec1Item2: 'teknik bir hata ya da mükerrer ödeme oluştu;',
    sec1Item3: "ödenen dijital içerik SHOT'un hatası yüzünden sağlanmadı;",
    sec1Item4: 'doğrulanmış başka teknik sorunlar tespit edildi.',
    sec1Note:
      'Her başvuru ayrı ayrı incelenir. Talep, yatırma tarihinden itibaren en geç 30 takvim günü içinde gönderilmelidir.',
    sec2Title: 'İade ne zaman mümkün değil',
    sec2Intro: 'Şu durumlarda iade yapılmaz:',
    sec2Item1: 'para zaten kullanıldı ya da katlandı;',
    sec2Item2: 'bakiye, dijital içerik ya da oyun içi eşya başarıyla alındı;',
    sec2Item3: 'eşya kullanıcının Steam hesabına aktarıldı;',
    sec2Item4: 'kullanıcı ödemeden sonra fikrini değiştirdi ya da Servis koşullarını okumadı;',
    sec2Item5: 'başvuru oyun mekaniklerinin sonuçlarıyla ilgili;',
    sec2Item6:
      'kullanıcı Servis koşullarını ihlal etti ya da dolandırıcılık veya iade sisteminin kötüye kullanımına dair belirtiler tespit edildi;',
    sec2Item7: 'yatırmanın üzerinden 30 takvim gününden fazla geçti.',
    sec3Title: 'Desteğe nasıl ulaşılır',
    sec3Before: 'SHOT destek ekibine ',
    sec3LinkWord: 'Destek',
    sec3After:
      ' bölümünde belirtilen iletişim kanallarından ulaşman gerekir. Doğrulama için ödeme bilgileri, ek veriler ya da belgeler istenebilir.',
    sec4Title: 'İnceleme süresi',
    sec4Text:
      'Başvuru, gerekli tüm bilgiler alındıktan sonra incelenir. Standart süre 30 takvim gününe kadardır. Ek doğrulama ya da ödeme sistemleriyle iletişim gerekirse süre uzatılabilir.',
    policyLink: 'Ayrıntılı iade politikası',
  },
});
